import { render, staticRenderFns } from "./index-v2.vue?vue&type=template&id=ffb5f8cc&scoped=true"
import script from "./index-v2.vue?vue&type=script&lang=js"
export * from "./index-v2.vue?vue&type=script&lang=js"
import style0 from "./index-v2.vue?vue&type=style&index=0&id=ffb5f8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb5f8cc",
  null
  
)

export default component.exports